module.exports = __webpack_public_path__ + "img/c02_buildingstartechnetlandline_Normal_ua.9c680dbd.webp";